import React from "react";

export default function SQLServer_FORMAT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_FORMAT</h1>
      <p>This is the SQLServer_FORMAT component generated from the SQL JSON.</p>
    </div>
  );
}
